export const metaTags = {
    home: {
        title: $localize`:@@common.meta-tags.home.title:Trang chủ | Đặt vé máy bay giá rẻ, ưu đãi hấp dẫn`,
        description: $localize`:@@common.meta-tags.home.description:Tìm kiếm và đặt vé máy bay giá rẻ với nhiều ưu đãi hấp dẫn. Đặt vé nhanh chóng, tiện lợi, hỗ trợ 24/7.`,
        keywords:
            'vé máy bay, đặt vé máy bay, vé máy bay giá rẻ, book flight, cheap flights, flight deals',
        robots: 'index, follow',
    },
    flight: {
        title: $localize`:@@common.meta-tags.flight.title:Vé máy bay | Đặt vé máy bay giá rẻ, hành trình thuận tiện`,
        description: $localize`:@@common.meta-tags.flight.description:Khám phá và đặt vé máy bay giá rẻ đến mọi điểm đến yêu thích của bạn. Nhiều ưu đãi hấp dẫn mỗi ngày!`,
        keywords:
            'vé máy bay, book flights, cheap airline tickets, đặt vé máy bay giá rẻ, flight promotions',
    },
    searchFlight: {
        title: $localize`:@@common.meta-tags.search-flight.title:Tìm kiếm chuyến bay | Tìm vé máy bay giá rẻ`,
        description: $localize`:@@common.meta-tags.search-flight.description:Tìm kiếm chuyến bay phù hợp với nhu cầu của bạn, so sánh giá vé và đặt vé dễ dàng chỉ trong vài bước.`,
        keywords:
            'tìm chuyến bay, so sánh giá vé, flight search, best flight deals, airline ticket comparison',
    },
    customerInfo: {
        title: $localize`:@@common.meta-tags.customer-info.title:Nhập thông tin hành khách | Đặt vé dễ dàng, nhanh chóng`,
        description: $localize`:@@common.meta-tags.customer-info.description:Điền thông tin hành khách để hoàn tất đặt vé máy bay. Đảm bảo chính xác để chuyến đi suôn sẻ.`,
        keywords:
            'thông tin hành khách, đặt vé máy bay, flight booking details, passenger details, secure booking',
    },
    payment: {
        title: $localize`:@@common.meta-tags.payment.title:Thanh toán | Mua vé máy bay an toàn`,
        description: $localize`:@@common.meta-tags.payment.description:Hoàn tất thanh toán cho đơn hàng vé máy bay của bạn với các phương thức thanh toán an toàn và linh hoạt.`,
        keywords:
            'thanh toán vé máy bay, secure payment, flight ticket payment, online flight booking, travel payment',
    },
    orderResult: {
        title: $localize`:@@common.meta-tags.order-result.title:Kết quả đặt chỗ | Xác nhận vé máy bay của bạn`,
        description: $localize`:@@common.meta-tags.order-result.description:Đặt vé thành công! Kiểm tra thông tin chuyến bay và xác nhận chi tiết vé máy bay của bạn.`,
        keywords:
            'kết quả đặt vé, xác nhận vé máy bay, booking confirmation, flight ticket status, travel itinerary',
    },
    shareFlight: {
        title: $localize`:@@common.meta-tags.share-flight.title:Chia sẻ chuyến bay | Gửi hành trình đến bạn bè`,
        description: $localize`:@@common.meta-tags.share-flight.description:Chia sẻ thông tin chuyến bay với người thân và bạn bè dễ dàng. Gửi chi tiết chuyến bay qua liên kết hoặc mạng xã hội.`,
    },
    promotion: {
        title: $localize`:@@common.meta-tags.promotion.title:Khuyến mãi | Ưu đãi vé máy bay mới nhất`,
        description: $localize`:@@common.meta-tags.promotion.description:Cập nhật các chương trình khuyến mãi, giảm giá vé máy bay hấp dẫn từ nhiều hãng hàng không.`,
        keywords:
            'khuyến mãi vé máy bay, flight promotions, travel discounts, airline deals, cheap flight tickets',
    },
    promotionDetail: {
        title: $localize`:@@common.meta-tags.promotion-detail.title:Chi tiết khuyến mãi | Săn vé rẻ ngay hôm nay`,
        description: $localize`:@@common.meta-tags.promotion-detail.description:Xem thông tin chi tiết về chương trình khuyến mãi vé máy bay và đặt vé ngay để nhận ưu đãi.`,
    },
    searchOrder: {
        title: $localize`:@@common.meta-tags.search-order.title:Tra cứu đơn hàng | Kiểm tra trạng thái đặt vé`,
        description: $localize`:@@common.meta-tags.search-order.description:Nhập mã đơn hàng để kiểm tra thông tin đặt vé máy bay và tình trạng thanh toán.`,
        keywords:
            'tìm kiếm đơn hàng, kiểm tra vé máy bay, flight booking check, travel order status',
    },
    searchOrderDetail: {
        title: $localize`:@@common.meta-tags.search-order-detail.title:Chi tiết đơn hàng | Xem thông tin đặt vé máy bay`,
        description: $localize`:@@common.meta-tags.search-order-detail.description:Kiểm tra chi tiết đơn hàng, tình trạng thanh toán và thông tin hành trình chuyến bay.`,
    },
    accountInformation: {
        title: $localize`:@@common.meta-tags.account-information.title:Tài khoản | Quản lý thông tin cá nhân`,
        description: $localize`:@@common.meta-tags.account-information.description:Quản lý thông tin cá nhân, đổi mật khẩu và cập nhật thông tin tài khoản dễ dàng.`,
        keywords:
            'quản lý tài khoản, thông tin cá nhân, user profile, account settings, travel profile',
    },
    accountOrders: {
        title: $localize`:@@common.meta-tags.account-orders.title:Đơn hàng | Xem lịch sử đặt vé máy bay`,
        description: $localize`:@@common.meta-tags.account-orders.description:Xem lịch sử đặt vé máy bay, chi tiết đơn hàng và tình trạng thanh toán.`,
        keywords:
            'lịch sử đặt vé, quản lý đơn hàng, flight booking history, my bookings, travel itinerary',
    },
    accountOrderDetail: {
        title: $localize`:@@common.meta-tags.account-order-detail.title:Chi tiết đơn hàng | Xem thông tin đặt vé máy bay`,
        description: $localize`:@@common.meta-tags.account-order-detail.description:Xem chi tiết đơn hàng, thông tin hành khách và tình trạng thanh toán.`,
    },
    contactUs: {
        title: $localize`:@@common.meta-tags.contact-us.title:Liên hệ | Hỗ trợ đặt vé máy bay`,
        description: $localize`:@@common.meta-tags.contact-us.description:Liên hệ với chúng tôi để được hỗ trợ đặt vé máy bay, giải đáp thắc mắc và góp ý.`,
        keywords: 'hỗ trợ khách hàng, liên hệ, customer support, travel assistance, flight help',
        robots: 'index, follow',
    },
    newAgency: {
        title: $localize`:@@common.meta-tags.new-agency.title:Tuyển đại lý | Hợp tác cùng Ngôi Nhà Phương Nam`,
        description: $localize`:@@common.meta-tags.new-agency.description:Đăng ký trở thành đại lý của Ngôi Nhà Phương Nam để nhận chính sách hoa hồng hấp dẫn và hỗ trợ kỹ thuật tận tâm.`,
        keywords:
            'tuyển đại lý, hợp tác đại lý, đối tác du lịch, Ngôi Nhà Phương Nam agency, đăng ký đại lý vé máy bay',
        robots: 'index, follow',
    },
    aboutUs: {
        title: $localize`:@@common.meta-tags.about-us.title:Giới thiệu | Về chúng tôi`,
        description: $localize`:@@common.meta-tags.about-us.description:Chúng tôi cung cấp dịch vụ đặt vé máy bay giá rẻ, nhanh chóng và tiện lợi.`,
        keywords:
            'về chúng tôi, đặt vé máy bay, travel agency, online flight booking, best travel service',
        robots: 'index, follow',
    },
    policy: {
        title: $localize`:@@common.meta-tags.policy.title:Chính sách bảo mật`,
        description: $localize`:@@common.meta-tags.policy.description:Xem thông tin về chính sách bảo mật, điều khoản sử dụng và quy định của chúng tôi.`,
        keywords:
            'chính sách bảo mật, bảo vệ thông tin, privacy policy, data security, user privacy',
        robots: 'index, follow',
    },
    termsAndConditions: {
        title: $localize`:@@common.meta-tags.terms.title:Điều khoản sử dụng`,
        description: $localize`:@@common.meta-tags.terms.description:Xem thông tin về điều khoản sử dụng và quy định của chúng tôi.`,
        keywords: 'điều khoản sử dụng, terms of service, user agreement, terms and conditions',
        robots: 'index, follow',
    },
    news: {
        title: $localize`:@@common.meta-tags.news.title:Tin tức | Cập nhật thông tin vé máy bay`,
        description: $localize`:@@common.meta-tags.news.description:Cập nhật tin tức, thông tin vé máy bay mới nhất từ nhiều hãng hàng không.`,
        keywords:
            'tin tức vé máy bay, flight news, travel updates, airline news, travel information',
    },
    newsCategory: {
        title: $localize`:@@common.meta-tags.news-category.title:Tin tức | Danh mục`,
        description: $localize`:@@common.meta-tags.news-category.description:Xem tin tức, thông tin vé máy bay theo từng danh mục cụ thể.`,
    },
    newsDetail: {
        title: $localize`:@@common.meta-tags.news-detail.title:Chi tiết tin tức | Tin nóng về hàng không & du lịch`,
        description: $localize`:@@common.meta-tags.news-detail.description:Xem thông tin chi tiết về các tin tức mới nhất trong lĩnh vực hàng không và du lịch.`,
    },
    link: {
        title: $localize`:@@common.meta-tags.link.title:Chia sẻ liên kết đặt vé máy bay`,
        description: $localize`:@@common.meta-tags.link.description:Gửi liên kết đặt vé máy bay cho người khác để hoàn tất quy trình đặt vé`,
    },
    notFound: {
        title: $localize`:@@common.meta-tags.not-found.title:Không tìm thấy trang | 404`,
        description: $localize`:@@common.meta-tags.not-found.description:Trang bạn đang tìm kiếm không tồn tại hoặc đã bị xóa.`,
        keywords: '404, trang không tồn tại, page not found, broken link, website error',
    },
    accessDenied: {
        title: $localize`:@@common.meta-tags.access-denied.title:Truy cập bị từ chối | 403`,
        description: $localize`:@@common.meta-tags.access-denied.description:Truy cập của bạn bị từ chối do không có quyền truy cập.`,
        keywords: '403, truy cập bị từ chối, access denied, unauthorized page, permission error',
    },
    accountVerification: {
        title: $localize`:@@common.meta-tags.account-verification.title:Xác minh tài khoản`,
        description: $localize`:@@common.meta-tags.account-verification.description:Xác minh tài khoản của bạn để truy cập tất cả các tính năng và đảm bảo an toàn cho thông tin cá nhân của bạn.`,
    },
    resetPassword: {
        title: $localize`:@@common.meta-tags.reset-password.title:Đặt lại mật khẩu`,
        description: $localize`:@@common.meta-tags.reset-password.description:Vui lòng thay đổi mật khẩu của bạn để bảo vệ thông tin cá nhân và đảm bảo an toàn cho tài khoản.`,
    },
    howToBook: {
        title: $localize`:@@common.meta-tags.how-to-book.title:Hướng dẫn đặt vé | Đặt vé nhanh chóng và tiện lợi`,
        description: $localize`:@@common.meta-tags.how-to-book.description:Hướng dẫn cách đặt vé máy bay trực tuyến nhanh chóng và tiện lợi.`,
        robots: 'index, follow',
        keywords:
            'cách đặt vé máy bay, hướng dẫn đặt vé máy bay, how to book flight, flight booking guide',
    },
    howToPay: {
        title: $localize`:@@common.meta-tags.how-to-pay.title:Hướng dẫn thanh toán | Thanh toán vé máy bay an toàn và tiện lợi`,
        description: $localize`:@@common.meta-tags.how-to-pay.description:Hướng dẫn cách thanh toán vé máy bay an toàn và tiện lợi.`,
        robots: 'index, follow',
        keywords:
            'cách thanh toán vé máy bay, hướng dẫn thanh toán vé máy bay, how to pay for flight, flight payment guide',
    },
};
